/* eslint-disable react/jsx-no-target-blank */
import React, {useEffect} from 'react'
import {AsideMenuItem} from './AsideMenuItem'
import _nav from '../../../../app/_nav'

type Props = {
  ticketItemCount:number
}

const AsideMenuMain: React.FC<Props> = ({
                                                    ticketItemCount
                                                  }) => {
    useEffect(() => {
         _nav.forEach((item, index) =>{
            if (item.to === "/tickets"){
item.ticketItemCount =ticketItemCount;
            }
        });
    }, [ticketItemCount]);


  return (
    <>
      {_nav.map((item, index) =>  <AsideMenuItem  key={index} {...item} />)}
    </>
  )
}


export {AsideMenuMain};